import { FC } from 'react';

import Table from 'modules/_shared/Table';

import EncumbrancesTableHeader from './components/EncumbrancesTableHeader';
import EncumbrancesTableBody from './components/EncumbrancesTableBody';

const EncumbrancesTable: FC = () => {
  const tableContent = (
    <>
      <EncumbrancesTableHeader />
      <EncumbrancesTableBody />
    </>
  );

  return <Table content={tableContent} scrollHorizontal />;
};

export default EncumbrancesTable;
